import { PageIdType } from 'generated-graphql';
import { initializeApollo } from 'lib/apolloClient';
import BlockMix from '@/components/BlockMix/BlockMix';

import { getGlobalData } from 'lib/global.js';
import { getEntityBlocks } from 'gql/common/blocks';
import appConfig from '@/app.config';

export default function Contact({
  pageBlocks,
}: {
  pageBlocks: any;
}) {

  return (
    <div>
      <BlockMix
        blocksData={pageBlocks?.editorBlocks}
        acfData={pageBlocks?.builder?.sections}
      />
    </div>
  );
}

export async function getStaticProps() {
  const apolloClient = initializeApollo();

  const pageBlocks = await apolloClient.query({
    query: getEntityBlocks(),
    variables: {
      id: 'contact',
      idType: PageIdType.Uri,
      asPreview: false,
    },
  });
  const pageProps = {
    pageBlocks: pageBlocks?.data?.page,
  };

  return await getGlobalData(pageProps, apolloClient, { revalidate: appConfig.revalidate });
}
